import React from "react";
import { Card, CardContent, Box, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CustomTypography from "../form/CustomTypography";
import { Address } from "../../../../models/Address/Address";

interface AddressCardProps {
  address: Address;
  isSelected: boolean;
  onSelect?: (address: Address) => void;
  onDelete?: (id: number) => void;
}

const AddressCard: React.FC<AddressCardProps> = ({
  address,
  isSelected,
  onSelect,
}) => {
  const theme = useTheme();

  const renderAddress = (...fields: (string | null | undefined)[]) =>
    fields.filter((field) => field).join(", ");

  return (
    <Card
      variant="outlined"
      sx={{
        border: isSelected
          ? `1px solid ${theme.palette.customColors.purple}`
          : "1px solid #e0e0e0",
        borderRadius: "0.3rem",
        boxShadow: isSelected ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none",
        position: "relative",
        cursor: "pointer",
        minHeight: "156px",
        maxHeight: "156px",
        overflow: "auto",
      }}
      onClick={() => (onSelect ? onSelect(address!) : undefined)}
    >
      {isSelected && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: `${theme.palette.customColors.purple}`,
          }}
        >
          <CheckCircleIcon />
        </Box>
      )}
      <CardContent sx={{ pl: 3, pr: 3 }}>
        {(address.first_name || address.last_name) && (
          <CustomTypography variant="body2" fontWeight={700}>
            {`${address.first_name || ""} ${address.last_name || ""}`.trim()}
          </CustomTypography>
        )}

        {(address.address1 || address.address2 || address.address3) && (
          <CustomTypography
            variant="body3"
            style={{ marginTop: 5 }}
            color="#7C7A7F"
          >
            {renderAddress(
              address.address1,
              address.address2,
              address.address3
            )}
          </CustomTypography>
        )}

        {(address.city_name ||
          address.state_name ||
          address.country_name ||
          address.postal_code) && (
          <CustomTypography variant="body3" color="#7C7A7F">
            {renderAddress(
              address.city_name,
              address.state_name,
              address.country_name,
              address.postal_code
            )}
          </CustomTypography>
        )}

        {address.contact_no && (
          <CustomTypography variant="body3" color="#7C7A7F">
            Contact No: {address.contact_no}
          </CustomTypography>
        )}

        {address.gstin && (
          <CustomTypography variant="body3" color="#7C7A7F">
            GSTIN: {address.gstin}
          </CustomTypography>
        )}

        {address.email && (
          <CustomTypography variant="body3" color="#7C7A7F">
            Email: {address.email}
          </CustomTypography>
        )}
      </CardContent>
    </Card>
  );
};

export default AddressCard;
